export default "__VITE_ASSET__DTHt$LCe__"